import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  typography: ({ numberOfLines }) => {
    return { ...theme.typography.limitNumberOfLines(numberOfLines) }
  },
}))
